var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 9",
    d: "M20.1663 2.15216C21.1002 -0.534518 24.8998 -0.534517 25.8337 2.15216L29.368 12.3199C29.78 13.5052 30.8861 14.3088 32.1406 14.3343L42.9029 14.5536C45.7466 14.6116 46.9208 18.2252 44.6542 19.9436L36.0762 26.447C35.0763 27.2051 34.6538 28.5053 35.0172 29.7063L38.1343 40.0097C38.958 42.7322 35.8841 44.9655 33.5493 43.3409L24.7135 37.1924C23.6836 36.4757 22.3164 36.4757 21.2865 37.1924L12.4507 43.3409C10.1159 44.9655 7.042 42.7322 7.86566 40.0097L10.9828 29.7063C11.3462 28.5053 10.9237 27.2051 9.92378 26.447L1.34581 19.9436C-0.920784 18.2252 0.253358 14.6116 3.09713 14.5536L13.8594 14.3343C15.1139 14.3088 16.22 13.5052 16.632 12.3199L20.1663 2.15216Z",
    fill: "#FFD84C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fda603eeba844edbdde31f07e7ac0568.svg";
export { ForwardRef as ReactComponent };